import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fectchEventDetailsAction } from "../redux/slices/eventSlices";
import "../styles/events.css";
import { Outlet, Link } from "react-router-dom";

export default function Event() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fectchEventDetailsAction());
  }, [dispatch]);

  const storeData = useSelector((store) => store?.event);
  const { pastEvents, futureEvents } = storeData;

  // console.log(pastEvents);
  // console.log(futureEvents);
  const knowMore = (eventId) => {
    navigate(`/events/${eventId}`);
  };

  return (
    <div className="mainSec">
      <div className="container">
        {/* {futureEvents?.length > 0 ? ( */}
        <section className="upcoming-events">
          <h2 className="eventHead">
            <span>Upcoming</span> Events
          </h2>

          <div className="event upcoming-event">
            <div className="event-poster">
              <img
                src="https://res.cloudinary.com/dwkrf89n4/image/upload/v1730651531/ofrjdp03lcfoprcxh4pw.jpg"
                alt="Event Poster"
              />
            </div>
            <div className="event-details">
              <div className="event-type">Hackathon</div>
              <div className="event-name">GeekVishwa 2.0</div>
              <Link
                to="/upcomingevent"
                style={{ color: "white", textDecoration: "none" }}
              >
                <button
                  style={{ color: "white" }}
                  type="button"
                  className="know-more upcoming-button"
                >
                  Know More!
                </button>
              </Link>
            </div>
          </div>

          {/*  
            {futureEvents.map((event1, index) => ( 
              <div className="event upcoming-event">
                <div className="event-poster">
                  <img src={event1.image1} alt="Event Poster" />
                </div>
                <div className="event-details">
                  <div className="event-type">{event1.keyword}</div>
                  <div className="event-name">{event1.name}</div>

                  <button
                    type="button"
                    onClick={() => knowMore(event1.id)}
                    className="know-more upcoming-button"
                  >
                    Know More
                  </button>
                </div>
              </div>
           ))} */}
        </section>
        {/* ) : null} */}

        {pastEvents?.length > 0 ? (
          <section className="past-events">
            <h2 className="eventHead">
              Past <span>Events</span>
            </h2>
            <div className="event-grid">
              {pastEvents.map((event1, index) => (
                <div className="event past-event">
                  <div className="event-poster">
                    <img src={event1.image1} alt="EventPoster" />
                  </div>
                  <div className="event-details">
                    <span className="event-type">{event1.keyword}</span>
                    <h3 className="event-name">{event1.name}</h3>
                    <button
                      type="button"
                      onClick={() => knowMore(event1.id)}
                      className="know-more past-button"
                    >
                      Know More
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ) : null}
      </div>
    </div>
  );
}
